import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Field, Formik, Form, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import { resetPassword, signIn } from "../../api/authService";
import { Icons } from "../../Components/Icons/Icons";
import SignImage from "../../Assets/Images/sign-in.webp"

const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(`Please ensure your email address includes the '@' symbol.`)
    .matches(
      /^(?!\.)(?!.*\.[.\s@])(?!.*\.$)[A-Z0-9._%+-]+@(?!\.)(?!.*\.[.\s])(?:[A-Z0-9-]+\.)+[A-Z]{2,}$/i,
      `Please ensure your email address includes the '@' symbol.`
    )
    .required(`Please ensure your email address includes the '@' symbol.`),
});

interface ResetPasswordData {
  email: string;
}

export const ResetPassword = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (values: ResetPasswordData) => {
    try {
      await resetPassword(values.email);
      navigate("/reset-code");
    } catch (error) {
      setError(`Sign in failed: ${error}`);
    }
  };

  return (
    <section className="sign">
      <img src={SignImage} alt="" />
      <div className="wrap">
        <div className="logo">
          {Icons.LogoIcon}
        </div>
        <div className="title">Reset your password</div>
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        <Formik
          initialValues={{ email: "" }}
          validationSchema={ResetPasswordSchema}
          onSubmit={(values) => handleSubmit(values)}
        >
          {({ isSubmitting, touched, errors }) => (
            <Form>
              <label htmlFor="email">
                <span>Email</span>
                <Field
                  type="email"
                  name="email"
                  className={touched.email && errors.email ? "error" : ""}
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-message"
                />
              </label>
              <button type="submit" disabled={isSubmitting} className="btn">
                Send code
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};
